(function(){
	'use strict';
	angular.module('app.setup')
		.controller('alertRolesCtrl', alertRolesCtrl);

	alertRolesCtrl.$inject = ['$scope', '$uibModal', 'leanFilterService', 'manageEmailAlertsService', 'tableService', 
		'tableRenderService', 'storeService'];

	function alertRolesCtrl($scope, $uibModal, leanFilterService, manageEmailAlertsService, tableService, 
			tableRenderService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var rendererParams = {'factoryNdx': adminConfig.factory.id};
		var reportSettingsName = 'ManageEmailAlerts';
		var reportSettingsId;

		if (jQuery('.inlineEditDiv').length) {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
		}

		var extraParams = [{}];
		var noPaging = true;

		var defaultFilters = [{
			'id': 'alert',
			'values': ['EarlyDelivery']
		}];

		$scope.$on('updateNoneSelected', function(event, args) {
			vm.noneSelected = args.noneSelected;
		});

		function unsubscribeSelected() {
			$scope.$broadcast('unsubscribeSelected', { type: 'role', factory: adminConfig.factory.id });
		};

		function setUrl() {
			var url = '{0}' + '/AlertSubscription/Type/';
			var aType = $scope.$parent.filterService.getSelectedIds('alert')[0] + '/Roles';
			return url + aType;
		}

		function subscribeModal() {
			var modalScope = $scope.$new();
			modalScope.selected = {};
			modalScope.selected.roles = [];
			var alertType = leanFilterService.getSelectedIds('alert')[0];
			manageEmailAlertsService.getUnsubscribed(alertType, 'Roles', adminConfig.factory.id)
				.then(function (data) {
					modalScope.roles = data;
				});

			modalScope.add = function () {
				var roleList = [];
				angular.forEach(modalScope.selected.roles, function (role) {
					roleList.push(role.role);
				});
				$scope.$broadcast('changeSubscription', { subscribe: true, list: roleList.toString(), type: 'role', factory: adminConfig.factory.id });
				instance.close();
				modalScope.$destroy();
			};

			var opts = {
				scope: modalScope,
				templateUrl: '/application/f/setup/subscribe_roles.html'
			};

			var instance = $uibModal.open(opts);
			modalScope.closeDialog = function () {
				instance.close();
				modalScope.$destroy();
			};
		};

		var columns = [{
			'id': 'isChecked',
			'display': '$checkbox',
			'renderer': tableRenderService.checkboxRenderer,
			'sort': false,
			'hideMenu': true,
			'width': 45
		},
		{
			'id': 'role',
			'display': 'Role',
			'sort': false,
			'hideMenu': true,
			'width': 200
		},
		{
			'id': 'conditions',
			'display': 'Conditions',
			'renderer': tableRenderService.conditionsRenderer,
			'sort': false,
			'hideMenu': true,
			'columnText': 'Only parts for each buyer',
			'width': 300
		}];

		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportUrl: setUrl(),
			noPaging: noPaging,
			columns: columns,
			pinnedColumns: [],
			defaultFilters: defaultFilters,
			defaultSort: 'role',
			defaultSortDirection: 'asc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			hideSearch: true,
			hideFiltersContainer: true,
			hideNoResultsSuggestion: true,
			hasTabs: true,
			setColumnDefaults: true,
			isGlobalReportSetting:true
		};

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.unsubscribeSelected = unsubscribeSelected;
		vm.subscribeModal = subscribeModal;

		vm.noneSelected = true;
	
		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			var url = setUrl();
			params.url = url;
			return tableService.getData(params, extraParams).then(function (response) {
				return response;
			});
		}

		init();

		function init() {
			$scope.filterService.clearFilters();
			$scope.filterService.useFactoryFilter = false;
			$scope.filterService.useAdminFactory = true;
			$scope.filterService.setMasterSingleSelectFilterList([
				$scope.filterService.filterDefinitions['AlertType']
			]);
		}
	};
})();
